import { PageLayout } from '../components/PageLayout';
import { AIEconomicsSection } from '../components/sections/AIEconomicsSection';

export const Economics = () => (
    <PageLayout>
        <AIEconomicsSection />
    </PageLayout>
);
